import { render, staticRenderFns } from "./RevokeTask.vue?vue&type=template&id=42040f47"
import script from "./RevokeTask.vue?vue&type=script&lang=js"
export * from "./RevokeTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports